/**
 * Disposal List Page — Item Disposal
 * Reuses ConsumptionListPage with formType="dispose".
 */
import ConsumptionListPage from './ConsumptionListPage';

export default function DisposalListPage() {
  return (
    <ConsumptionListPage
      formType="dispose"
      pageId="icm-disposals"
      title="Item Disposal"
    />
  );
}
